import React, { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import {
  setUpdateDurationType,
  UPDATE_DURATION_TYPE,
  updateDurationTypeSelector,
} from 'features/courseResume';
import Field from 'components/Field';
import RadioInput from 'components/RadioInput';

function UpdateDurationTypeField() {
  const dispatch = useDispatch();
  const durationType = useSelector(updateDurationTypeSelector);

  const handleTypeChange = useCallback(
    (event) => {
      dispatch(setUpdateDurationType(event.target.value));
    },
    [dispatch]
  );

  return (
    <Field
      label="Select type of duration change"
      labelClassName="h4 normal"
      className="m-b-m"
    >
      <RadioInput
        value={UPDATE_DURATION_TYPE.extend}
        isChecked={durationType === UPDATE_DURATION_TYPE.extend}
        onChange={handleTypeChange}
      >
        Extend Duration
      </RadioInput>
      <RadioInput
        value={UPDATE_DURATION_TYPE.reduce}
        isChecked={durationType === UPDATE_DURATION_TYPE.reduce}
        onChange={handleTypeChange}
      >
        Reduce Duration
      </RadioInput>
    </Field>
  );
}

export default UpdateDurationTypeField;
